var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-posts" },
    [
      _vm.showLoader
        ? _c("component-loader", {
            attrs: { progress: 90, unlimitedProgress: true, activeClose: true },
            on: {
              close: function ($event) {
                _vm.showLoader = false
              },
            },
          })
        : _vm._e(),
      _vm.pages
        ? _c(
            "div",
            {
              ref: "loadableCalendar",
              staticClass:
                "calendar-wrapper table-wrapper scrollable calendar-table",
              class: _vm.name + "-table",
            },
            [
              _c(
                "div",
                { staticClass: "select-week" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "previous",
                      on: {
                        click: function ($event) {
                          return _vm.changeWeek("previous")
                        },
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass:
                            "vs-icon notranslate icon-scale material-icons null",
                        },
                        [_vm._v("chevron_left")]
                      ),
                    ]
                  ),
                  _c("component-datepicker", {
                    staticClass: "posts-datepicker",
                    attrs: {
                      date: new Date(_vm.currentDate),
                      noLimit: true,
                      eventOpen: _vm.openDatePicker,
                    },
                    on: { picked: _vm.picked },
                  }),
                  _c(
                    "span",
                    {
                      on: {
                        click: function ($event) {
                          _vm.openDatePicker = !_vm.openDatePicker
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          `${_vm.$t(`dash.planner.week`)} ${_vm.startDate
                            .locale(this.$i18n.locale)
                            .format("LL")}`
                        )
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "next",
                      on: {
                        click: function ($event) {
                          return _vm.changeWeek("next")
                        },
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass:
                            "vs-icon notranslate icon-scale material-icons null",
                        },
                        [_vm._v("chevron_right")]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  ref: "loadableCalendarContent",
                  staticClass: "calendar-content",
                },
                [
                  _c("div", { staticClass: "scrollable-x" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "calendar-body head-days",
                        attrs: { id: "calendar-content-days" },
                      },
                      _vm._l(_vm.calendar, function (day, key) {
                        return _c(
                          "li",
                          {
                            key: key,
                            staticClass: "column day",
                            class: `day-${key}`,
                          },
                          [
                            _c("ul", { staticClass: "calendar-head" }, [
                              _c("li", { staticClass: "column day-column" }, [
                                _c(
                                  "p",
                                  {
                                    class: [
                                      {
                                        past: _vm.checkPast(
                                          day.day,
                                          _vm.currentDate.hours()
                                        ),
                                        current: _vm.checkCurrent(day.day),
                                      },
                                    ],
                                  },
                                  [
                                    _c("span", { staticClass: "day" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t(
                                              `dash.week.${_vm
                                                .formatDayEn(day.day, "dddd")
                                                .toLowerCase()}`
                                            )
                                            .substr(0, 3)
                                        ) +
                                          " " +
                                          _vm._s(_vm.formatDate(day.day, "DD"))
                                      ),
                                    ]),
                                    _c("span", { staticClass: "posts" }, [
                                      _vm._v(_vm._s(_vm.nbPostsDay(key))),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _c(
                      "ul",
                      {
                        staticClass: "calendar-body scrollable",
                        attrs: { id: "calendar-content" },
                        on: { scroll: _vm.handleScroll },
                      },
                      _vm._l(_vm.calendar, function (day, key) {
                        return _c(
                          "li",
                          {
                            key: key,
                            staticClass: "column day",
                            class: `day-${key}`,
                          },
                          [
                            _c(
                              "ul",
                              { staticClass: "posts" },
                              _vm._l(day.slots, function (post, indexPost) {
                                return _c(
                                  "div",
                                  { key: indexPost, staticClass: "post-cell" },
                                  [
                                    _c(
                                      "li",
                                      {
                                        staticClass: "post",
                                        class: [
                                          post.status,
                                          {
                                            reshare:
                                              post.page &&
                                              post.page[0] &&
                                              post.page[0].is_reshare,
                                          },
                                          {
                                            retweet:
                                              post.page &&
                                              post.page[0] &&
                                              post.page[0].is_retweet,
                                          },
                                          {
                                            story:
                                              post.page &&
                                              post.page[0] &&
                                              post.page[0].story,
                                          },
                                        ],
                                        attrs: {
                                          "data-qa": `planner-post-${post.status}`,
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            $event.preventDefault()
                                            return _vm.clickPost(post)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "page-rs" },
                                          [
                                            _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.findPage(
                                                    post._bots[0].page
                                                  ).name,
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c("page-image-avatar", {
                                                  attrs: {
                                                    page: _vm.findPage(
                                                      post._bots[0].page
                                                    ),
                                                  },
                                                }),
                                                _vm._v(
                                                  "\n                       \n                    "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        post.status == "preview" ||
                                        post.status == "slot" ||
                                        post.status == "failed" ||
                                        post.status == "inprogress"
                                          ? _c(
                                              "Tooltip",
                                              {
                                                attrs: {
                                                  text: _vm.$t(
                                                    _vm.getTooltip(post)
                                                  ),
                                                  position: "top",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "content" },
                                                  [
                                                    post.status != "slot" &&
                                                    ((post._bots[0] &&
                                                      post._bots[0].mode ===
                                                        "story" &&
                                                      post._bots[0].page &&
                                                      post._bots[0].page
                                                        .story_config &&
                                                      post._bots[0].page
                                                        .story_config
                                                        .created) ||
                                                      (post._bots &&
                                                        post._bots.mode ===
                                                          "story" &&
                                                        post._bots.page &&
                                                        post._bots.page
                                                          .story_config &&
                                                        post._bots.page
                                                          .story_config
                                                          .created))
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "story-img-planner",
                                                          },
                                                          [
                                                            _c("img", {
                                                              attrs: {
                                                                src: post.enclosure,
                                                                alt: "",
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            }),
                                                            _c("p", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getText(
                                                                    post,
                                                                    true
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : post.status != "slot" &&
                                                        post.enclosure
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "thumb-wrapper",
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "thumb",
                                                              attrs: {
                                                                src: post.enclosure,
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    post.status != "slot"
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getText(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  `dash.post.slot.empty`
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "info" },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "date" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getDate(post)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    post.status != "slot"
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            staticClass: "type",
                                                            attrs: {
                                                              text: _vm.$t(
                                                                _vm.getTypeTooltip(
                                                                  post
                                                                )
                                                              ),
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.getTypePost(
                                                                    post
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "span",
                                                      { staticClass: "state" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              `dash.post.${post.status}`
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            )
                                          : post.page &&
                                            post.page[0] &&
                                            post.page[0].is_reshare
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "content" },
                                                [
                                                  post.enclosure
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "thumb-wrapper",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "thumb",
                                                            attrs: {
                                                              src: post.enclosure,
                                                            },
                                                            on: {
                                                              error:
                                                                _vm.replaceByDefault,
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "title" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          post.page[0]
                                                            .reshare_message
                                                        ) +
                                                          " - " +
                                                          _vm._s(
                                                            _vm.getText(post)
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "info" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "date" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getDate(post)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  post.status != "slot"
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass: "type",
                                                          attrs: {
                                                            text: _vm.$t(
                                                              _vm.getTypeTooltip(
                                                                post
                                                              )
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getTypePost(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            "\n                         \n                      "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "state" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            `dash.post.reshare`
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : post.page &&
                                            post.page[0] &&
                                            post.page[0].is_retweet
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "content" },
                                                [
                                                  post.enclosure
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "thumb-wrapper",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "thumb",
                                                            attrs: {
                                                              src: post.enclosure,
                                                            },
                                                            on: {
                                                              error:
                                                                _vm.replaceByDefault,
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "title" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getText(post)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "info" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "date" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getDate(post)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  post.status != "slot"
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass: "type",
                                                          attrs: {
                                                            text: _vm.$t(
                                                              _vm.getTypeTooltip(
                                                                post
                                                              )
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getTypePost(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "state" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            `dash.posts.retweet`
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "content" },
                                                [
                                                  post.enclosure
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "thumb-wrapper",
                                                        },
                                                        [
                                                          Array.isArray(
                                                            post._bots
                                                          ) &&
                                                          post._bots.length >
                                                            0 &&
                                                          post._bots[0].mode ===
                                                            "story" &&
                                                          post.page &&
                                                          post.page[0] &&
                                                          post.page[0].story
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "story-screenshot-planner",
                                                                attrs: {
                                                                  src: JSON.parse(
                                                                    post.page[0]
                                                                      .story
                                                                  ).screenshot,
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.replaceByDefault,
                                                                },
                                                              })
                                                            : post._bots &&
                                                              post._bots
                                                                .mode ===
                                                                "story" &&
                                                              post.page &&
                                                              post.page[0] &&
                                                              post.page[0].story
                                                            ? _c("img", {
                                                                staticClass:
                                                                  "story-screenshot-planner",
                                                                attrs: {
                                                                  src: JSON.parse(
                                                                    post.page[0]
                                                                      .story
                                                                  ).screenshot,
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.replaceByDefault,
                                                                },
                                                              })
                                                            : _c("img", {
                                                                staticClass:
                                                                  "thumb",
                                                                attrs: {
                                                                  src: post.enclosure,
                                                                },
                                                                on: {
                                                                  error:
                                                                    _vm.replaceByDefault,
                                                                },
                                                              }),
                                                        ]
                                                      )
                                                    : post.page &&
                                                      post.page[0] &&
                                                      post.page[0].video
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "thumb-wrapper",
                                                        },
                                                        [
                                                          _c("video", {
                                                            staticClass:
                                                              "video-thumb",
                                                            attrs: {
                                                              width: "75",
                                                              src: post.page[0]
                                                                .video,
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "title" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getText(post)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "info" },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "date" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getDate(post)
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  post.status != "slot"
                                                    ? _c(
                                                        "Tooltip",
                                                        {
                                                          staticClass: "type",
                                                          attrs: {
                                                            text: _vm.$t(
                                                              _vm.getTypeTooltip(
                                                                post
                                                              )
                                                            ),
                                                            position: "top",
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getTypePost(
                                                                  post
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    { staticClass: "state" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            `dash.post.${post.status}`
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.showSidebar
        ? _c(
            "vs-popup",
            {
              class: `sidebar-action ${_vm.version}`,
              attrs: { title: ``, active: _vm.showSidebar },
              on: {
                "update:active": function ($event) {
                  _vm.showSidebar = $event
                },
              },
            },
            [
              _c("component-post-sidebar", {
                attrs: {
                  gridData: _vm.gridData,
                  post: _vm.post,
                  sectionPlanner: true,
                  invite: true,
                },
                on: {
                  addComment: _vm.addComment,
                  validate: _vm.validatePost,
                  openLoader: _vm.openLoader,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }